import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { AbstractApiService } from '@bn/shared/core/abstracts/abstract-api.service';
import { Search } from '@bn/shared/core/api';

@Injectable({
  providedIn: 'root',
})
export class SearchService extends AbstractApiService {
  public constructor() {
    super();
    this.apiUrl = `${this.envConfig.apiUrl}/search`;
  }

  public getSearchResults(searchTerm: string): Observable<Search> {
    return this.httpClient.get<Search>(`${this.apiUrl}?search=${searchTerm}`);
  }
}
